import * as hazardDefectsActions from '../actions/hazardsDefects';

const defaultState = {
    form: {
        initialValues: {},
        initialStatus: {
            errors: {},
        },
    },
    selectedDefect: null,
    selectedLocation: null,
    hazards: [],
    hazard: null,
    actionTypes: [],
    tags: [],
    isLoading: true,
    documentLabels: [],
};

export default function (state = defaultState, action = null) {
    switch (action.type) {
        case hazardDefectsActions.FORM_OPTIONS_REFRESHED:
            return {
                ...state,
            };
        case hazardDefectsActions.TOGGLE_LOADING:
            return {
                ...state,
                isLoading: action.isLoading,
            };
        case hazardDefectsActions.DEFECT_SELECTED:
            return {
                ...state,
                selectedDefect: {
                    ...action.selectedDefect,
                    hazards: [...action.selectedDefect.hazards],
                },
            };
        case hazardDefectsActions.ADD_DEFECT_HAZARD:
            return {
                ...state,
                selectedDefect: {
                    ...state.selectedDefect,
                    hazards: [
                        ...state.selectedDefect.hazards,
                        {
                            ...state.hazards.find(
                                (hazard) => hazard.id === action.hazardId
                            ),
                        },
                    ],
                },
            };
        case hazardDefectsActions.DELETE_DEFECT_HAZARD:
            return {
                ...state,
                selectedDefect: {
                    ...state.selectedDefect,
                    hazards: state.selectedDefect.hazards.filter(
                        (item, index) => index !== action.index
                    ),
                },
            };
        case hazardDefectsActions.UPDATE_DEFECT_HAZARD:
            return {
                ...state,
                selectedDefect: {
                    ...state.selectedDefect,
                    hazards: state.selectedDefect.hazards.map((item, index) =>
                        index === action.index
                            ? {
                                  ...state.hazards.find(
                                      (hazard) => hazard.id === action.value
                                  ),
                              }
                            : item
                    ),
                },
            };

        case hazardDefectsActions.ADD_DEFECT_TAG:
            return {
                ...state,
                selectedDefect: {
                    ...state.selectedDefect,
                    tags: [
                        ...state.selectedDefect.tags,
                        {
                            ...state.tags.find(
                                (tag) => tag.id === action.tagId
                            ),
                        },
                    ],
                },
            };
        case hazardDefectsActions.DELETE_DEFECT_TAG:
            return {
                ...state,
                selectedDefect: {
                    ...state.selectedDefect,
                    tags: state.selectedDefect.tags.filter(
                        (item, index) => index !== action.index
                    ),
                },
            };
        case hazardDefectsActions.UPDATE_DEFECT_TAG:
            return {
                ...state,
                selectedDefect: {
                    ...state.selectedDefect,
                    tags: state.selectedDefect.tags.map((item, index) =>
                        index === action.index
                            ? {
                                  ...state.tags.find(
                                      (tag) => tag.id === action.value
                                  ),
                              }
                            : item
                    ),
                },
            };
        case hazardDefectsActions.LOCATION_SELECTED:
            return {
                ...state,
                selectedLocation: action.selectedLocation,
            };

        case hazardDefectsActions.FORM_REFRESHED:
            return {
                ...state,
                form: action.form,
            };

        case hazardDefectsActions.UPDATE_ALL_HAZARDS:
            return {
                ...state,
                hazards: action.hazards,
            };

        case hazardDefectsActions.UPDATE_ALL_TAGS:
            return {
                ...state,
                tags: action.tags,
            };

        case hazardDefectsActions.UPDATE_ALL_DOCUMENT_LABELS:
            return {
                ...state,
                documentLabels: action.labels,
            };

        case hazardDefectsActions.UPDATE_ACTION_TYPES:
            return {
                ...state,
                actionTypes: action.actionTypes,
            };

        case hazardDefectsActions.SET_HAZARD:
            return {
                ...state,
                hazard: action.hazard,
            };

        default:
            return state;
    }
}
